import React from 'react';
import styled from 'styled-components';

import MessagesInbox from '../../../_organisms/MessagesInbox';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import SectionHeader from '../../../_molecules/SectionHeader';
import SectionBreadcrumbs from '../../../_molecules/SectionBreadcrumbs';
import SectionBreadcrumb from '../../../_molecules/SectionBreadcrumb';
import { BodyLarge, H3, LinkSmall } from '@styled';
import { mediaQueries } from '@general/breakpoints';

import useDocumentTitle from '@hooks/useDocumentTitle';

const breakpoint = mediaQueries.md;

const ContainerStyled = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    @media ${breakpoint} {
        padding-left: 0;
        padding-right: 0;
    }
`;

const MessagesIndex = () => {
    const { documentTitle } = useDocumentTitle('My ICSC Messages');

    return (
        <ErrorHandler>
            <TrackPageView>
                <ContainerStyled>
                    <SectionHeader title={documentTitle} />

                    <div className="flex justify-content-between mt-2">
                        <SectionBreadcrumbs>
                            <SectionBreadcrumb route="/my-icsc/messages">Messages</SectionBreadcrumb>
                            <SectionBreadcrumb isActive>Inbox</SectionBreadcrumb>
                        </SectionBreadcrumbs>

                        <div>
                            <LinkSmall href="https://view.ceros.com/icsc/icsc-networking-platfrom/p/1" target="_blank">
                                {'How to use the Networking Platform>>'}
                            </LinkSmall>
                        </div>
                    </div>

                    <H3 className="mt-3 mb-4">Inbox</H3>
                    <BodyLarge>Message other ICSC members and event attendees.</BodyLarge>
                    <div className="mt-4">
                        <MessagesInbox />
                    </div>
                </ContainerStyled>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default MessagesIndex;
